export const BehanceIcon = () => {
  return (
    <svg
      width={18}
      height={19}
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.263 8.53s1.703-.125 1.703-2.097c0-1.97-1.393-2.933-3.158-2.933H0v11.017h5.808s3.545.11 3.545-3.252c0 0 .155-2.735-2.09-2.735zM5.39 5.458h.418s.79 0 .79 1.146-.465 1.313-.992 1.313H2.56V5.458h2.83zm.254 7.1H2.559V9.614h3.249s1.176-.015 1.176 1.513c0 1.289-.878 1.422-1.34 1.431zm8.438-6.255c-4.292 0-4.289 4.233-4.289 4.233s-.294 4.21 4.289 4.21c0 0 3.819.216 3.819-2.928h-1.964s.065 1.184-1.79 1.184c0 0-1.964.13-1.964-1.917h5.783s.633-4.782-3.884-4.782zm-1.92 3.311s.24-1.698 1.963-1.698c1.724 0 1.703 1.698 1.703 1.698H12.16zm4.123-4.108h-4.604V4.149h4.604v1.357z"
        fill="#697484" // is changing to #fff by hover
      />
    </svg>
  )
}